// Module
var code = "<div class=\"md-whiteframe-z1 mn-module flex layout-column\" ui-view>\r\n</div>";
// Exports
module.exports = code;